import styled from 'styled-components';
import { colorGray } from '/imports/ui/stylesheets/styled-components/palette';

const Title = styled.li`
  color: ${colorGray};
  font-weight: 600;
  width: 100%;
`;

export default {
  Title,
};
